import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import './styles/index.less'
import Vant from 'vant'
import '@/utils/rem'
import VueClipboard from 'vue-clipboard2'
import { getUrlParams } from '@/utils'

import { getConnectKey } from '@/utils/utils'
Vue.config.productionTip = false

if (process.env.NODE_ENV != 'production') {
  let vconsole = require('vconsole')
  const vConsole = new vconsole()
  Vue.use(vConsole)
}

Vue.use(Vant)
Vue.use(VueClipboard)


if (window.webkit || window.syjs) {
  SyHybridSdk.encryptfun().then(res => {
    init()
  })
} else {
  init()
}

function init() {
  let params = getUrlParams(window.location.href)
  if (params.sid) {
    window.localStorage.setItem('sid', params.sid)
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
